<template>
  <div class="auth-layout row align-content--center" style="background-image: none !important;">
    <div id="vanta"></div>
    <div class="flex xs12 pa-3 flex-center">
      <div class="py-5 flex-center">
        <va-icon-vuestic />
      </div>
    </div>
    <div class="flex xs12 flex-center">
      <div class="flex-center">
        <language-dropdown class="app-navbar-actions__item"/>
      </div>
    </div>

    <div class="flex xs12 pa-3">
      <div class="d-flex justify--center">
        <va-card class="auth-layout__card">
          <va-tabs
            v-model="tabIndex"
            center
          >
            <va-tab>{{ $t('auth.login') }}</va-tab>
            <va-tab>{{ $t('auth.createNewAccount') }}</va-tab>
          </va-tabs>

          <va-separator/>

          <div class="pa-3">
            <router-view/>
          </div>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import VaIconVuestic from '../../iconset/VaIconVuestic'
import LanguageDropdown from '@/components/admin/app-navbar/components/dropdowns/LanguageDropdown.vue'

const tabs = [
  'login',
  'signup',
]

export default {
  name: 'AuthLayout',
  components: { VaIconVuestic, LanguageDropdown },
  data () {
    return {
      selectedTabIndex: 0,
      tabTitles: ['login', 'createNewAccount'],
    }
  },
  computed: {
    tabIndex: {
      set (tabIndex) {
        this.$router.push({ name: tabs[tabIndex] })
      },
      get () {
        return tabs.indexOf(this.$route.name)
      },
    },
  },
  mounted () {
    const threeScript = document.createElement('script')
    threeScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r121/three.min.js'

    const vantaScript = document.createElement('script')
    vantaScript.src = 'https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.net.min.js'

    threeScript.addEventListener('load', () => {
      vantaScript.addEventListener('load', () => {
        if (window.VANTA) {
          window.VANTA.NET({
            el: '#vanta',
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            minHeight: 200.0,
            minWidth: 200.0,
            scale: 1.0,
            scaleMobile: 1.0,
          })
        }
      })

      document.head.appendChild(vantaScript)
    })

    document.head.appendChild(threeScript)
  },
}
</script>

<style lang="scss">
#vanta {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  display: block;
  height: 100%;
  width: 100%;
}

.auth-layout {
  min-height: 100vh;
  //background-image: linear-gradient(to right, #0e4ac4, #002c85);
  //background-color: rgb(131, 150, 165) !important;

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }

    .link {
      color: rgb(108, 127, 238) !important;
    }
  }

  img {
    max-width: 100%;
    height: 60px;
  }

  .va-input {
    &__container {
      &__label {
        color: rgb(108, 127, 238) !important;
      }
    }
  }

  .va-select {
    &__label {
      color: rgb(108, 127, 238) !important;
    }

    &__option {
      color: inherit !important;
      background-color: transparent !important;

      &:hover {
        background: rgba(108, 127, 238, 0.2) !important;
      }

      &.va-select {
        &__option--selected {
          color: rgb(108, 127, 238) !important;
          background-color: rgba(108, 127, 238, 0.2) !important;
        }
      }
    }
  }

  .va-checkbox {
    &--selected.va-checkbox {
      .va-checkbox {
        &__input {
          background: rgb(108, 127, 238) !important;
        }
      }
    }
  }

  ::selection {
    background-color: #6c7fee;
    color: #ffffff;
  }

  .va-tabs {
    &__slider-wrapper {
      background-color: rgb(108, 127, 238) !important;
    }
  }
}
</style>
